import { Trans } from '@lingui/macro';
import { Button, Center, Stack, Text } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import { useTypedSearchParams } from 'react-router-typesafe-routes/dom';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { SignInForm } from '../../domains/sign-in/sign-in';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import {
  routeResetPassword,
  routeSignIn,
  routeSignUp,
} from '../../router/routes';

import styles from './sign-in.page.module.css';

export const SignInPage = () => {
  const navigate = useNavigate();
  const [signInParams] = useTypedSearchParams(routeSignIn);

  const handleSignUp = () => {
    const cont = signInParams.continue;

    if (cont === 'order-ticket') {
      const tripid = signInParams.tripid;
      const startStation = signInParams.startStation;
      const endStation = signInParams.endStation;

      const path = routeSignUp.buildPath(
        {},
        {
          continue: cont,
          tripid: Number(tripid),
          startStation: Number(startStation),
          endStation: Number(endStation),
        }
      );

      return navigate(path);
    }

    return navigate(routeSignUp.path);
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.headerTitle}>
          <Trans>Вход в личный кабинет</Trans>
        </h1>
        <MainSideMenu />
      </header>
      <main className={styles.main}>
        <Stack>
          <UiCard>
            <SignInForm />
          </UiCard>

          <UiCard>
            <Center>
              <Text>
                <Trans>Забыли пароль?</Trans>
              </Text>
            </Center>
            <Button
              to={routeResetPassword.path}
              component={Link}
              size="md"
              mt="xs"
              variant="outline"
              fullWidth
            >
              <Trans>Изменить пароль</Trans>
            </Button>
          </UiCard>

          <UiCard>
            <Center>
              <Text>
                <Trans>Еще не зарегистрированны?</Trans>
              </Text>
            </Center>
            <Button
              size="md"
              mt="xs"
              fullWidth
              variant="outline"
              onClick={handleSignUp}
            >
              <Trans>Зарегистрироваться</Trans>
            </Button>
          </UiCard>
        </Stack>
      </main>
    </div>
  );
};
